import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useMemo, useCallback, useEffect } from 'react';
import { isSocialWalletConnector } from '@dynamic-labs/wallet-connector-core';
import { useInternalDynamicContext } from '../DynamicContext/useInternalDynamicContext.js';
import { useViewContext } from '../ViewContext/ViewContext.js';
import '@dynamic-labs/utils';
import '@dynamic-labs/sdk-api';
import '../../config/ApiEndpoint.js';
import { logger } from '../../shared/logger.js';
import '../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '../../utils/constants/colors.js';
import 'ethers';
import '../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import { getReferencedAccount } from '../../utils/functions/getReferencedAccount/getReferencedAccount.js';
import '@dynamic-labs/rpc-providers';
import { useVerifyWallet } from '../../utils/hooks/useVerifyWallet/useVerifyWallet.js';
import 'react-dom';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../ThemeContext/ThemeContext.js';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../components/IconButton/IconButton.js';
import '../../components/Alert/Alert.js';
import '@dynamic-labs/wallet-book';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import '../../components/MenuList/Dropdown/Dropdown.js';
import '../MockContext/MockContext.js';
import { useErrorContext } from '../ErrorContext/ErrorContext.js';
import '../CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';

const SocialRedirectContext = createContext(undefined);
const SocialRedirectContextProvider = ({ children, }) => {
    var _a, _b;
    const { setShowAuthFlow, wallets, setSelectedWalletConnector, disableWalletConfirmationOnce, consumeNonce, displayTermsOfService, environmentId, projectSettings, setIsSingleWalletAccount, setShowDynamicUserProfile, isAuthenticated, setPrimaryWalletId, secondaryWallets, sdkHasLoaded, authToken, } = useInternalDynamicContext();
    const { setErrorMessage } = useErrorContext();
    const { setView } = useViewContext();
    const verifyWallet = useVerifyWallet({
        consumeNonce,
        displayTermsOfService,
        environmentId,
        projectSettings,
        setIsSingleWalletAccount,
    });
    const enabledSocialProvidersInDb = (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.socialSignIn) === null || _a === void 0 ? void 0 : _a.providers) !== null && _b !== void 0 ? _b : [];
    const enabledSocialProviders = enabledSocialProvidersInDb
        .filter((provider) => provider.enabled)
        .map((provider) => provider.provider);
    const socialWalletConnector = wallets
        .map(({ walletConnector }) => walletConnector)
        .find(isSocialWalletConnector);
    const [redirectStatus, setRedirectStatus] = useState('idle');
    const [socialProvider, setSocialProvider] = useState();
    const wallet = secondaryWallets.find((wallet) => wallet.connector.key === (socialWalletConnector === null || socialWalletConnector === void 0 ? void 0 : socialWalletConnector.key));
    const socialAccount = useMemo(() => (wallet ? getReferencedAccount(authToken, wallet.id) : undefined), [authToken, wallet]);
    const handleError = useCallback((message) => {
        logger.error(message);
        if (isAuthenticated) {
            setShowAuthFlow(false);
            setShowDynamicUserProfile(true);
        }
        else {
            setShowAuthFlow(true);
            setView('wallet-list');
            setErrorMessage('-1');
        }
    }, [
        isAuthenticated,
        setErrorMessage,
        setShowAuthFlow,
        setShowDynamicUserProfile,
        setView,
    ]);
    useEffect(() => {
        var _a, _b;
        if (!projectSettings || !socialWalletConnector || !sdkHasLoaded) {
            // todo: we are competing with the useEffect in ViewContext.
            // once that is cleaned up, we can remove this code
            const params = new URLSearchParams(window.location.search);
            if (params.has('magic_oauth_request_id')) {
                setView('social-redirect-view');
                setShowAuthFlow(true);
            }
            return;
        }
        const params = new URLSearchParams(window.location.search);
        if (params.has('error') && params.has('provider')) {
            const errorDescription = params.get('error_description');
            handleError(errorDescription !== null && errorDescription !== void 0 ? errorDescription : 'Unknown error');
            // calling this to clear the relevant query params
            (_a = socialWalletConnector.getSession) === null || _a === void 0 ? void 0 : _a.call(socialWalletConnector);
            return;
        }
        if (params.has('magic_oauth_request_id')) {
            const providerFromParams = params.get('provider');
            setSocialProvider(providerFromParams);
            setRedirectStatus('loading');
            setView('social-redirect-view');
            setShowAuthFlow(true);
            if (!isAuthenticated) {
                setSelectedWalletConnector(socialWalletConnector);
            }
            (_b = socialWalletConnector
                .getSession) === null || _b === void 0 ? void 0 : _b.call(socialWalletConnector).then((session) => __awaiter(void 0, void 0, void 0, function* () {
                /**
                 * If the user is already authenticated, that means that they are in the process
                 * of setting their social wallet as their primary wallet. At this point, they
                 * have successfully re-authenticated with the social provider. We can now finish
                 * the setPrimaryWallet flow
                 */
                if (isAuthenticated) {
                    if (!socialAccount) {
                        throw new Error('Social account not found');
                    }
                    if (socialAccount.oauthAccountId === session.oauthId) {
                        // justification: socialAccount is defined if and only if wallet is also defined
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        setPrimaryWalletId(wallet.id);
                        setShowAuthFlow(false);
                        setShowDynamicUserProfile(true);
                    }
                    else {
                        yield socialWalletConnector.endSession();
                        setView('social-wrong-account');
                    }
                }
                else {
                    const address = yield socialWalletConnector.fetchPublicAddress();
                    disableWalletConfirmationOnce();
                    yield verifyWallet({
                        oauth: {
                            accessToken: session.accessToken,
                            didToken: session.didToken,
                            provider: providerFromParams,
                        },
                        /**
                         * justification: if the user just successfully authenticated their social,
                         * then the social connector must return an address
                         */
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        publicWalletAddress: address,
                        walletConnector: socialWalletConnector,
                    });
                }
                setSocialProvider(undefined);
                setRedirectStatus('success');
            })).catch((error) => {
                setSocialProvider(undefined);
                setRedirectStatus('error');
                handleError(error);
            });
        }
    }, [
        socialAccount,
        authToken,
        isAuthenticated,
        projectSettings,
        sdkHasLoaded,
        secondaryWallets,
        setPrimaryWalletId,
        setSelectedWalletConnector,
        setShowAuthFlow,
        setShowDynamicUserProfile,
        setView,
        socialWalletConnector,
        verifyWallet,
        disableWalletConfirmationOnce,
        wallet,
        handleError,
    ]);
    return (jsx(SocialRedirectContext.Provider, Object.assign({ value: {
            enabledSocialProviders,
            redirectStatus,
            setSocialProvider,
            socialAccount,
            socialProvider,
            socialWalletConnector,
        } }, { children: children })));
};
const useSocialRedirectContext = () => {
    const context = useContext(SocialRedirectContext);
    if (context === undefined) {
        throw new Error('useSocialRedirectContext must be used within a SocialRedirectContextProvider');
    }
    return context;
};

export { SocialRedirectContext, SocialRedirectContextProvider, useSocialRedirectContext };
